(function () {
  const initModule = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const mode = root.dataset.mode || 'slider';
    const defaultPos = Number(root.dataset.defaultPosition || 50);
    const autoplay = root.dataset.autoplay === 'true';
    const delay = Math.max(2000, Number(root.dataset.autoplayDelay || 5500));
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const mediaPanels = Array.from(root.querySelectorAll('[data-case-panel="media"]'));
    const contentPanels = Array.from(root.querySelectorAll('[data-case-panel="content"]'));
    const triggers = Array.from(root.querySelectorAll('[data-case-trigger]'));
    const prevBtn = root.querySelector('[data-case-prev]');
    const nextBtn = root.querySelector('[data-case-next]');

    if (!mediaPanels.length || !contentPanels.length) return;

    const total = Math.min(mediaPanels.length, contentPanels.length);
    let active = 0;
    let timer = null;

    const stopAuto = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAuto = () => {
      if (!autoplay || prefersReducedMotion || mode !== 'slider' || total < 2) return;
      stopAuto();
      timer = window.setInterval(() => {
        setActive((active + 1) % total, false);
      }, delay);
    };

    const clamp = (index) => {
      if (index < 0) return total - 1;
      if (index >= total) return 0;
      return index;
    };

    const syncCompare = (panel) => {
      const compare = panel.querySelector('[data-compare]');
      const input = panel.querySelector('[data-compare-input]');
      if (!compare || !input) return;

      if (!input.dataset.bound) {
        input.value = String(defaultPos);
        const update = () => {
          const val = Math.max(10, Math.min(90, Number(input.value || defaultPos)));
          compare.style.setProperty('--ba-pos', `${val}%`);
        };

        input.addEventListener('input', update);
        update();
        input.dataset.bound = 'true';
      }
    };

    const setActive = (index, userAction = true) => {
      active = clamp(index);

      mediaPanels.forEach((panel, i) => {
        const isActive = i === active;
        panel.classList.toggle('hidden', !isActive);
        panel.toggleAttribute('hidden', !isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (i === active) syncCompare(panel);
      });

      contentPanels.forEach((panel, i) => {
        const isActive = i === active;
        panel.classList.toggle('hidden', !isActive);
        panel.toggleAttribute('hidden', !isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      triggers.forEach((trigger, i) => {
        const activeTrigger = i === active;
        trigger.setAttribute('aria-selected', activeTrigger ? 'true' : 'false');
        trigger.setAttribute('tabindex', activeTrigger ? '0' : '-1');
        trigger.classList.toggle('border-primary', activeTrigger);
        trigger.classList.toggle('bg-primary', activeTrigger);
        trigger.classList.toggle('text-white', activeTrigger);
        trigger.classList.toggle('border-slate-300', !activeTrigger);
        trigger.classList.toggle('bg-white', !activeTrigger);
        trigger.classList.toggle('text-slate-700', !activeTrigger);
      });

      if (userAction) startAuto();
    };

    triggers.forEach((trigger, triggerIndex) => {
      trigger.addEventListener('click', () => {
        const idx = Number(trigger.dataset.caseIndex || 0);
        setActive(idx);
      });

      trigger.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (triggerIndex + 1) % triggers.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (triggerIndex - 1 + triggers.length) % triggers.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = triggers.length - 1;
        }

        if (nextIndex === null) return;
        event.preventDefault();
        setActive(nextIndex);
        triggers[nextIndex]?.focus();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => setActive(active - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => setActive(active + 1));

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', (event) => {
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      startAuto();
    });

    setActive(0, false);
    startAuto();
  };

  const boot = () => {
    document.querySelectorAll('[data-before-after]').forEach(initModule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
